import { render, staticRenderFns } from "./CreateBudget.vue?vue&type=template&id=21a539b7&scoped=true"
import script from "./CreateBudget.vue?vue&type=script&lang=js"
export * from "./CreateBudget.vue?vue&type=script&lang=js"
import style0 from "./CreateBudget.vue?vue&type=style&index=0&id=21a539b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a539b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a539b7')) {
      api.createRecord('21a539b7', component.options)
    } else {
      api.reload('21a539b7', component.options)
    }
    module.hot.accept("./CreateBudget.vue?vue&type=template&id=21a539b7&scoped=true", function () {
      api.rerender('21a539b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/budget/components/CreateBudget.vue"
export default component.exports